document.addEventListener('DOMContentLoaded', function () {
  
  const inventoryData = JSON.parse(document.getElementById('variant-inventory-data').textContent);
  const inventoryLog = document.getElementById('inventory-log');
  const variantSelector = document.querySelector('select[name="options[Finish]"]');
  // console.log('INVENTORY COUNT RUNNING');
  if (variantSelector && inventoryLog) {
    const updateInventory = (selectedValue) => {
      const selectedVariant = Object.entries(inventoryData).find(([key, variant]) => {
        return variant.title.trim() === selectedValue.trim();
      });

      if (selectedVariant) {
        const count = selectedVariant[1].inventory_quantity;
        if (count > 0 && count < 10) {
          inventoryLog.textContent = count;
          inventoryLog.closest('.inventory-message-wrapper').style.display = 'block';
        } else {
          inventoryLog.closest('.inventory-message-wrapper').style.display = 'none';
        }
      }
    };

    updateInventory(variantSelector.value);

    variantSelector.addEventListener('change', function () {
      updateInventory(this.value);
    });
  }
});
